import React from 'react';
import { Typography, Box } from '@material-ui/core';
import { Lock as LockIcon } from '@material-ui/icons';

import { FormFooterConstants } from './FormFooter.constants';
import { useStyles } from './FormFooter.styles';

export default function FormFooter() {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <Box className={classes.wrapper}>
        <Box className={classes.item}>
          <Box className={`${classes.greenCircle} ${classes.circle}`}>
            <LockIcon fontSize="default" className={classes.icon} />
          </Box>
          <Typography className={classes.text}>
            {FormFooterConstants.EncryptedConnection}
          </Typography>
        </Box>
        <Box className={classes.item}>
          <Box className={`${classes.blueCircle} ${classes.circle}`}>
            <Typography
              variant="h5"
              component="span"
              className={classes.countTu}
            >
              20
            </Typography>
          </Box>
          <Typography className={classes.text}>
            {FormFooterConstants.OfferFromTU}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
